'use client';
import { ReportActionsheet } from './report-actionsheet';
import { StoryReportModal } from './story-report-modal';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  storyId: string;
  seriesId: string;
};

export const ReportContainer = ({ storyId, seriesId }: Props) => {
  const {
    isOpen,
    open,
    close,
    onClickInappropiateContent,
    isReportModalOpen,
    closeReportModal,
    submitDisabled,
    setCaptchaToken,
    onChangeType,
    onChangeMessage,
    handleSubmit,
  } = useLocalHooks(storyId);

  return (
    <>
      <ReportActionsheet
        seriesId={seriesId}
        storyId={storyId}
        isOpen={isOpen}
        open={open}
        close={close}
        onClickInappropiateContent={onClickInappropiateContent}
      />
      <StoryReportModal
        isOpen={isReportModalOpen}
        onClose={closeReportModal}
        onChangeType={onChangeType}
        onChangeMessage={onChangeMessage}
        setCaptchaToken={setCaptchaToken}
        onSubmit={handleSubmit}
        submitDisabled={submitDisabled}
      />
    </>
  );
};
